export interface ProfiloStudenteUpdate {
  nome?: string;
  cognome?: string;
  emailsGenitori?: string[];
  email?: string;
  dataNascita?: String;
  sesso?: boolean;
  registrato?: boolean;
}
